/**
 * The CSRF token, held in memory.
 *
 * A leaf module on purpose: it imports nothing. `Api.ts` already imports the
 * Redux store, and the store imports the auth slice — so the moment the slice
 * imports `Api.ts` to stash the token, the cycle
 * `Authentication.slice → Api → store → Authentication.slice` closes. Its
 * outcome then depends on which module the bundler happens to evaluate first,
 * and reaching the slice before the store hands `configureStore` an `undefined`
 * reducer, which throws at boot. Nothing can import this file's dependencies
 * because it has none, so the cycle cannot form.
 *
 * It cannot come from a cookie. The portal and the API are on different hosts,
 * so any cookie the API sets is host-only to the API's host and invisible to
 * this code — `document.cookie` would always return null.
 *
 * Memory rather than localStorage: the token defends against forged
 * cross-origin requests, and storing it would hand it to exactly the XSS that
 * the httpOnly session cookie is out of reach of.
 */
let csrfToken: string | null = null

export const setCsrfToken = (token: string | null | undefined): void => {
	if (token) csrfToken = token
}

export const clearCsrfToken = (): void => {
	csrfToken = null
}

export const readCsrfToken = (): string | null => csrfToken
